import "./Partnership.css";
import ZoneHeading from "./ZoneHeading";

const Partnership = () => {
  const Step = ({ stepName, children }) => {
    return (
      <div className="partnership-step">
        <h4>{stepName}</h4>
        <p>{children}</p>
      </div>
    );
  };

  const HowWeHelpRow = ({ header, items }) => {
    return (
      <div className="how-we-help-row">
        <div className="how-we-help-row-header">
          <h3>{header}</h3>
        </div>
        <div className="how-we-help-row-content">
          <ul>
            {items.map((el, idx) => {
              return <li key={idx}>{el}</li>;
            })}
          </ul>
        </div>
      </div>
    );
  };

  return (
    <div className="partnership-zone">
      <div className="zone">
        <ZoneHeading id="partnership">Partnership</ZoneHeading>
        <p>
          Your legacy is important to us. We recognize the hard work you have
          put in to grow your business, and our goal is to continue to build
          upon what you have already achieved.
        </p>
        <div className="sub-zone">
          <h3>Our Process</h3>
          <p>
            We tailor our approach to fit you and your company's needs. We have
            an efficient, streamlined path to close a deal with the structure
            and timeline that works for you. We can close a deal within 2-3
            months, depending on data availability. We pride ourselves on
            closing quickly and painlessly.
          </p>
          <div className="partnership-steps">
            <Step stepName="Step 1: Introductory Call">
              Speak with a member of the Aquitaine team about your business and
              learn a bit more about us. We discuss your goals for a transaction
              and whether it's a potential fit for us and for you.
            </Step>
            <Step stepName="Step 2: Preliminary Diligence">
              We sign an NDA and get information about your business. We focus
              on the fundamental information that will “make or break” a deal to
              make sure we are using everyone's time effectively.
            </Step>
            <Step stepName="Step 3: Letter of Intent">
              We discuss the potential key terms of a transaction and
              memorialize them in a letter of intent ("LOI"). We don't make last
              minute changes or re-negotiate unless there is a surprising and
              meaningful diligence finding - our goal is to execute a deal
              according to the terms laid out in the LOI.
            </Step>
            <Step stepName="Step 4: Confirmatory DD and Advisor Workstreams (Accounting, Legal, Etc)">
              We analyze additional information about your business, bringing in
              accountants to review your financials and lawyers to begin
              drafting transaction documents. Throughout this process we get to
              know each other better and work on our post-transaction growth
              strategy for the business.
            </Step>
            <Step stepName="Step 5: Close the Deal">
              Sign transaction documents, close the deal, and celebrate!
            </Step>
          </div>

          <div className="sub-zone">
            <h3>How We Help</h3>
            <p>
              There is no "one size fits all" for how we work with portfolio
              companies. We offer the network and tools to support company needs
              and work with management to determine the best ways we can add
              value.
            </p>
            <p>
              Whether we are providing additional support through an ownership
              transition or providing support to existing management to realize
              additional growth, we bring whatever resources are necessary to
              build for the long-term.
            </p>
          </div>

          <div className="sub-zone">
            <p className="how-we-help-text-header">
              We have developed the network and tools to support company needs.
            </p>
            <div className="how-we-help-grid">
              <HowWeHelpRow
                header="Network"
                items={[
                  "Sales and marketing analysis to expand customer acquisition, cross-sell, and upsell",
                  "Industry experts in our network contribute to diligence and value creation plans",
                  "Connectivity to M&A add-ons and new technologies expand company capabilities",
                ]}
              />
              <HowWeHelpRow
                header="Organic Growth Drivers"
                items={[
                  "Customer experience and loyalty studies to improve engagement and quality of service",
                  "Pricing analysis to identify potential revenue opportunities",
                  "Sales and marketing analysis to expand customer acquisition, cross-sell, and upsell",
                ]}
              />
              <HowWeHelpRow
                header="Operational Performance"
                items={[
                  "KPI tracking to instill and reinforce best practices",
                  "Customer tools to improve client experience and retention",
                  "Accessing/utilizing data through new processes and technology",
                ]}
              />
              <HowWeHelpRow
                header="M&A Sourcing and Execution"
                items={[
                  "Financing/DD skills to facilitate efficient and thoughtful M&A addons",
                  "Integration support to ensure successful post-close transition",
                  '"Tuck-in" to strategic extensions of services and capabilities',
                ]}
              />
              <HowWeHelpRow
                header="Value Realization"
                items={[
                  "Industry relationships with potential acquirors or JV partners",
                  "Lender connections for debt-financed M&A or recapitalizations",
                  "Optimizing for exit through assistance with process approach and timing",
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partnership;
